import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-cogs',
      title: 'Digital Product Engineering',
      description: 'From ideation to launch, our comprehensive suite of product engineering services and solutions helps bring your products to life.',
      link: '#'
    },
    {
      icon: 'fas fa-laptop-code',
      title: 'Technology Solutions',
      description: 'With a rich legacy of transformative technology solutions, we forge ahead, adapting to the dynamic needs of industries worldwide.',
      link: '#'
    },
    {
      icon: 'fas fa-brain',
      title: 'Artificial Intelligence',
      description: 'Leverage the power of AI to unlock your competitive edge, no matter where you stand in your AI journey.',
      link: '#'
    },
    {
      icon: 'fas fa-plug',
      title: 'Platform & Integrations',
      description: 'Ensure enhanced productivity and scalability with our extensive set of services, tailored to elevate your capabilities.',
      link: '#'
    },
    {
      icon: 'fas fa-digital-tachograph',
      title: 'Digital Transformation',
      description: 'The digital landscape is rapidly evolving. We help you stay ahead and simplify the way your business moves.',
      link: '#'
    },
    {
      icon: 'fas fa-headset',
      title: 'Support Services',
      description: 'From Remote Infrastructure Management (RIM) to tech-enabled services, we support your company\'s core business and meet your unique requirements.',
      link: '#'
    }
  ];

  return (
    <section className="services-section">
      <div className="container">
        <div className="section-header">
          <h2>Our Services</h2>
          <h3>Agile, Innovative, and Always Moving Forward</h3>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h4>{service.title}</h4>
              <p>{service.description}</p>
              <a href={service.link} className="service-link">Know more</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 